import { render, staticRenderFns } from "./PrescriptionPage.vue?vue&type=template&id=60e7fe89&"
import script from "./PrescriptionPage.vue?vue&type=script&lang=ts&"
export * from "./PrescriptionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports